import { ApiHandler, createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { EmployeeCollectionModel, EmployeeModel, getEmployeeById, getEmployeeCollection } from "@tCentro/Services/CENAdminEmployeeService";
import { ProductTypeModel } from "@tCentro/Services/CENAdminProductTypeService";
 
export interface GetEmployeeByIdParameter extends HasOnSuccess<EmployeeModel>, HasOnError<string> {
    id: string;
}
 
type HandlerType = ApiHandler<GetEmployeeByIdParameter, { apiResult: EmployeeModel }>;
 
export const GetEmployeeById: HandlerType = async props => {
    try {
           const result = await getEmployeeById(props.parameter.id);
           if (props.parameter.onSuccess) {
               props.parameter.onSuccess(result);
           }
       } catch (error: any) {
           if (props.parameter.onError) {
               props.parameter.onError(error?.message ?? "Failed to load employees");
           }
       }
};
 
export const chain = [GetEmployeeById];
const getEmployeesById = createHandlerChainRunner(chain, "getEmployeesById");
export default getEmployeesById;
